document.addEventListener("DOMContentLoaded", function () {
  const isSubmitted = window.location.search.includes('customer_posted=true');

  if (isSubmitted) {
    const footer = document.querySelector('#footer-bottom-ctm');

    if (footer) {
      // delay to override Shopify's anchor scroll
      setTimeout(() => {
        footer.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 300);
    }
  }
});